import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAccountRegistryData } from "../../../../../store/actions/precog/accoutRegistry";
import { Input } from "antd";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const AccountRegistryTab = ({account}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [accountData, setAccountData] = useState({});

  useEffect(()=>{      
    dispatch(getAccountRegistryData(account.accountCode))
      .then(res => {        
        setAccountData(res.data?.accountExtraInfo);
      });
  },[]);

  return (
    <div data-testid="AccountRegistryTab" className="registry-tab-container" >
      <div className="registry-tab-header">
        <div className="registry-tab-header-row">
          <div className="registry-tab-header-row-label">
            <FormattedMessage id="preCog.drawerDetail.accountDescription" />
          </div>
          <Input
            className="inputCustom drawer-inputCustom"
            disabled={true}
            value={`${account?.accountDesc} (${account?.accountCode})`}
          />
        </div>
        <div className="registry-tab-header-row">
          <div className="registry-tab-header-row-label">
            <FormattedMessage id="preCog.drawerDetail.accountType.label" />
          </div>
          <Input
            className="inputCustom drawer-inputCustom"
            disabled={true}
            value={account?.accountType && intl.formatMessage({id: `preCog.drawerDetail.accountType.${account?.accountType}`})}           
          />
        </div>
      </div>
      <div className="registry-tab-section">
        <div className="pre-cog-assets-drawer-titles">
          <FormattedMessage id="preCog.drawerDetail.noDeductibility" />
        </div>
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.irpefOrIres" />:</span><b>{accountData.nonDeductibleRate} %</b>
        </div>
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.fiscalIrap" />:</span><b>{accountData.nonDeductibleIrapRate} %</b>
        </div>
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.civilisticIrap" /></span><b>{accountData.nonDeductibleStatutoryIrapRate} %</b>
        </div>
      </div>
      <div className="registry-tab-section">
        <div className="pre-cog-assets-drawer-titles">
          <FormattedMessage id="preCog.accountingLines.table.vat" />
        </div>
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.nonDeductibilityPercentage" />:</span><b>{accountData.nonDeductibleVATRate} %</b>
        </div>
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.vatDestination" />:</span><b>{accountData.vatDestinationDesc}</b>
        </div>
      </div>
      <div className="registry-tab-section">
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.subjectToWitholdingTax" />:</span><b>{accountData.withholding ? "SI" : "NO"}</b>
        </div>
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.fixedAssetsAccount" />:</span><b>{accountData.isAsset ? "SI" : "NO"}</b>
        </div>
        {/** Gianluca: con Andrea Tibi si è deciso di tralasciare per il momento "Soggetto a sospensione", perchè a suo avviso non ha senso in questa schermata. Attualmente non sapremmo come valorizzarlo
         * 
        <div className="registry-tab-section-row">
          <span><FormattedMessage id="preCog.drawerDetail.subjectToSuspension" />:</span><b>{accountData.subjectToSuspension}</b>
        </div>
         */}
      </div>
    </div>);
};

export default AccountRegistryTab;
